import { t } from '@lingui/core/macro';
import { NoddiCard } from 'noddi-ui-web';
import MastercardSvg from './assets/Mastercard';
import VisaSvg from './assets/Visa';
import klarnaImage from './assets/klarna.png';
import vippsImage from './assets/vipps.png';

export const PaymentOptionsInstructions = () => {
  return (
    <NoddiCard title={t`Easy and safe payment`} contentClassName='flex flex-col gap-2' icon='CreditCard'>
      <p className='text-sm text-muted-foreground'>{t`To confirm the booking, you can pay easily and securely using one of our payment methods`}</p>
      <div className='flex flex-wrap items-center gap-4'>
        <div className='flex h-12 items-center'>
          <img src={vippsImage} alt='Vipps' className='w-14' />
        </div>
        <div className='flex h-12 items-center'>
          <img src={klarnaImage} alt='Klarna' className='h-full w-auto' />
        </div>
        <div className='flex h-12 items-center'>
          <VisaSvg className='h-full w-auto' />
        </div>
        <div className='flex h-12 items-center'>
          <MastercardSvg className='h-full w-auto' />
        </div>
      </div>
    </NoddiCard>
  );
};
